import { render, staticRenderFns } from "./Wifi.vue?vue&type=template&id=684ba31a&scoped=true"
import script from "./Wifi.vue?vue&type=script&lang=js"
export * from "./Wifi.vue?vue&type=script&lang=js"
import style0 from "./Wifi.vue?vue&type=style&index=0&id=684ba31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684ba31a",
  null
  
)

export default component.exports